import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';
import featureFlags, {FeatureFlagName} from '../../../utils/featureFlags';

const TOUR_GLOBAL_KEY = 'globalTourSeen';

interface TourProviderProps {
  children: ReactNode;
}

type TourContextType = {
  globalSeen: boolean;
  markGlobalSeen: () => void;
};

const TourContext = createContext<TourContextType>({
  globalSeen: false,
  markGlobalSeen: () => {
    throw new Error('markGlobalSeen must be used within a TourProvider');
  },
});

export const TourProvider: React.FC<TourProviderProps> = ({children}) => {
  const [globalSeen, setGlobalSeen] = useState(false);

  useEffect(() => {
    const seenValue = localStorage.getItem(TOUR_GLOBAL_KEY);
    const featureEnabled = featureFlags.get(FeatureFlagName.Tour);
    if (seenValue === 'true' || !featureEnabled) {
      markGlobalSeen();
    }
  }, []);

  const markGlobalSeen = () => {
    localStorage.setItem(TOUR_GLOBAL_KEY, 'true');
    setGlobalSeen(true);
  };

  return (
    <TourContext.Provider value={{globalSeen, markGlobalSeen}}>
      {children}
    </TourContext.Provider>
  );
};

export const useTour = () => useContext(TourContext);
